"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const industries = [{
  id: 1,
  title: "Corporate",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1488905/img/corporate_meeting_room.png",
  description: "Elevate your corporate communications with state-of-the-art LED walls and digital signage. Our solutions enhance presentations, collaboration spaces, and lobby displays, creating impactful visual experiences for employees and visitors alike."
}, {
  id: 2,
  title: "Education",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1488905/img/interactive_classroom.png",
  description: "Transform learning environments with interactive touch screens and dynamic display technology. Our education solutions foster engagement, collaboration, and modern teaching methods that prepare students for the digital future."
}, {
  id: 3,
  title: "Retail",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1488905/img/retail_digital_display.png",
  description: "Captivate customers and drive sales with vibrant digital signage and LED display solutions. Our retail technology creates immersive shopping experiences, showcases products dynamically, and delivers targeted messaging at the right moment."
}];
export default function IndustriesServed() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section id="industries-served" className="w-full bg-light-background py-16 px-4 md:px-8">
      <div className="mx-auto max-w-7xl">
        <h2 className="mb-12 text-center text-3xl font-bold text-foreground-light md:text-4xl">
          Industries Served
        </h2>
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {industries.map((industry, i) => <div key={industry.id} data-index={i} ref={refs[i]} className="transition-all duration-200 ease-out" style={{
          opacity: visibilities[i] ? 1 : 0,
          transform: visibilities[i] ? "translateY(0)" : "translateY(20px)",
          transitionDelay: `${i * 100}ms`
        }}>
              <Card className="group overflow-hidden shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium">
                <div className="overflow-hidden">
                  <img src={industry.image} alt={industry.title} className="h-48 w-full object-cover transition-transform duration-300 ease-out group-hover:scale-103" />
                </div>
                <CardHeader>
                  <CardTitle className="text-lg font-semibold text-foreground-light">
                    {industry.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-sm leading-relaxed text-foreground-light">
                    {industry.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}